import { Component, Inject, OnInit, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import { DateValidator } from 'src/app/common/classes/date-validator';
import { Multiplexor } from 'src/app/common/classes/multiplexor';
import { Validator } from 'src/app/common/classes/validator';
import { DateFormat } from 'src/app/core/constants/app.constant';
import { InventoryService } from 'src/app/modules/inventory/inventory.service';
import { IResponse } from 'src/app/shared/models/app';
import { EodReportService } from '../eod-report.service';

@Component({
    selector: 'nphs-user-configure-eod',
    templateUrl: './configure-eod.component.html',
    styleUrls: ['./configure-eod.component.scss'],
    standalone: false
})
export class ConfigureEodComponent implements OnInit {
  data = {
    daysOfWeek: [],
  };
  eodConfig = {
    recipients: [],
    defaultUser: [],
    selectedRecipients: [],
    alertOn: false,
    id: null,
    daysOfWeek: { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false },
    dateTimeError: false,
    dateFormatError: false,
    dateTime: null,
    dateTimeInput: null,
    errors: [],
    validator: new Validator(),
    mandatoryItems: ['selectedRecipients', 'dateTime'],
  }
  multiplexor = new Multiplexor(['ActiveUserList'], this.setMasterData.bind(this));

  constructor(
    public dialog: MatDialogRef<ConfigureEodComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    private toaster: ToastrService,
    private inventoryService: InventoryService,
    private eodReportService: EodReportService

  ) { }

  ngOnInit(): void {
    this.load();

  }

  load() {
    this.inventoryService.getActiveUserList().subscribe((response: IResponse) => {
      if (!response.hasError) {
        this.multiplexor.input('ActiveUserList', response.data);
      }
    });
    this.data.daysOfWeek = [{ id: 1, value: 'M' }, { id: 2, value: 'T' }, { id: 3, value: 'W' }, { id: 4, value: 'T' }, { id: 5, value: 'F' },
    { id: 6, value: 'S' }, { id: 7, value: 'S' }];
  }

  setMasterData(data) {
    this.eodConfig.recipients = data.ActiveUserList.activeUsers;
    this.eodConfig.defaultUser = data.ActiveUserList.defaultUser;
    this.init();
  }

  // eodAlertConfigValidator = new EodAlertConfigValidator();

  init() {
    this.eodConfig.alertOn = true;
    let data = this.dialogData.data;
    console.log(data)
    if (data) {
      this.eodConfig.id = data.id;
      this.eodConfig.alertOn = data.active;
      if (data.active) {
        this.eodConfig.selectedRecipients = [];
        if (this.eodConfig.recipients) {
          this.eodConfig.recipients.forEach((recipient) => {
            data.recipients.forEach((selectedRec) => {
              if (recipient.id == selectedRec.id) {
                this.eodConfig.selectedRecipients.push(recipient);
              }
            });
          });
        }
        if (data.schedDays) {
          data.schedDays.split(',').forEach(day => {
            this.eodConfig.daysOfWeek[day] = true;
          });
        }
        // this.eodConfig.dateTime = new Date(moment(data.dateTime).format(DateFormat.MMDDYYYYHMM));
        this.eodConfig.dateTime = moment(data.dateTime).format(DateFormat.HHMM);

      }
    } else {
      // this.eodConfig.dateTime = moment(new Date(), DateFormat.HHMM).toDate();
      this.eodConfig.dateTime =  moment().format(DateFormat.HHMM);
      this.changeDate();
    }
    this.reloadRecipients();
  }

  reloadRecipients() {
    // $timeout(function () {
    //   $('#multi-select-recipient').fSelect('reload');
    // }, 500);

    setTimeout(() => {
      // $('#multi-select-recipient').fSelect('reload');
    }, 500);
  }

  toggleEodAlertConfig() {
    // this.eodConfig.dateTime = moment(convertToShipToTime(new Date()), DateFormat.MMDDYYYYHMM).toDate();
    this.eodConfig.dateTime =  moment().format(DateFormat.HHMM);
    this.changeDate();

    // this.eodAlertConfigValidator = new EodAlertConfigValidator();

    if (this.eodConfig.alertOn) {
      this.eodConfig.alertOn = false;
      this.eodConfig.daysOfWeek = { 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false };
    } else {
      this.eodConfig.alertOn = true;
    }
    this.eodConfig.selectedRecipients = [];
    this.reloadRecipients();
  }

  changeDate() {
    this.eodConfig.dateTimeError = false;
    this.eodConfig.dateFormatError = false;
    this.eodConfig.dateTimeInput = moment(this.eodConfig.dateTime).format(DateFormat.MMDDYYYYHMM);
  }

  changeDateInput() {
    if (this.eodConfig.dateTimeInput) {
      var error = new DateValidator().validate(this.eodConfig.dateTimeInput);
      if (!error) {
        this.eodConfig.dateTime = moment(this.eodConfig.dateTimeInput, DateFormat.MMDDYYYYHMM).toDate();
        // this.eodConfig.dateTime = moment(this.eodConfig.dateTimeInput).utc().format('HH:mm');
        this.eodConfig.dateTimeError = false;
      } else {
        this.eodConfig.dateTimeError = true;
      }
    }
  }

  isDayOfWeekSelected(id) {
    let retVal = false;
    retVal = this.eodConfig.daysOfWeek[id];
    return retVal;

  }

  toggleDayOfWeek(id) {
    this.eodConfig.daysOfWeek[id] = !this.eodConfig.daysOfWeek[id];
  }

  saveEodConfig() {
    if(this.validate(this.eodConfig)){

    if (this.eodConfig.id) {
      this.eodReportService.eodUpdateConfiguration(this.eodConfig)
      this.dialog.close();
      this.toaster.success("saved successfully.", "", { closeButton: true });
    }
    else {
      this.eodReportService.eodCreateConfiguration(this.eodConfig).subscribe((response: IResponse) => {
        if (!response.hasError) {
          this.dialog.close();
          this.toaster.success("saved successfully.", "", { closeButton: true });
        }

      });
    }

  }

  }


  // VALIDATIONS

  validate(eodConfig) {
    let retVal = true;
    this.reset();
    if (eodConfig.alertOn) {
      this.eodConfig.errors = this.eodConfig.validator.validate(eodConfig, this.eodConfig.mandatoryItems);
      this.weeklyValidate(eodConfig);
    }
    return !this.hasAnyError();
  }


  reset() {
    this.eodConfig.errors = [];
  }

  weeklyValidate(eodConfig) {
    var chosen = false;
    if (eodConfig.daysOfWeek['1']) { chosen = true; }
    if (eodConfig.daysOfWeek['2']) { chosen = true; }
    if (eodConfig.daysOfWeek['3']) { chosen = true; }
    if (eodConfig.daysOfWeek['4']) { chosen = true; }
    if (eodConfig.daysOfWeek['5']) { chosen = true; }
    if (eodConfig.daysOfWeek['6']) { chosen = true; }
    if (eodConfig.daysOfWeek['7']) { chosen = true; }

    if (!chosen) {
      this.eodConfig.errors.push("weeklyFrequency");
    }
  }

  revalidate(field) {
    var errorIndex = this.eodConfig.errors.indexOf(field);
    if (errorIndex >= 0) {
      this.eodConfig.errors.splice(errorIndex, 1);
    }
  }
  hasAnyError() {
    return this.eodConfig.errors.length > 0;
  }

  // VALIDATIONS



}
